/* eslint-disable no-constant-binary-expression */
/* eslint-disable react/prop-types */
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import "./styles.css";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../hooks/useAuthContext";
import { toast } from "react-toastify";
import api from "../../services/axiosConfig";
import { formatCpfCnpj } from "../../utils/cpfCnpjFormatter";
import { formatPhone } from "../../utils/telefoneFormatter";

function ModalChavesPix({
  isOpen,
  onClose,
  chavesPix,
  cadastroObrigatorio = false,
}) {
  const { userData, exibirLogs, fetchLoggedUser } = useContext(Context);
  const [chaves, setChaves] = useState([]);
  const [segundoPix, setSegundoPix] = useState(false);

  useEffect(() => {
    if (!userData) return;

    const chavesDoUsuario = Array.isArray(chavesPix) ? chavesPix : [];

    const preenchidas = chavesDoUsuario.map((chave, i) => ({
      tipo: chave?.tipo || "",
      chave: chave?.chave || "",
      isPrincipal: chave?.isPrincipal ?? i === 0,
    }));

    while (preenchidas.length < 2) {
      preenchidas.push({
        tipo: "",
        chave: "",
        isPrincipal: false,
      });
    }

    setChaves(preenchidas);
    setSegundoPix(
      preenchidas[1]?.tipo?.trim() !== "" ||
        preenchidas[1]?.chave?.trim() !== ""
    );
  }, [chavesPix, userData]);

  const handlePrincipalChange = (index) => {
    const novasChaves = chaves.map((chave, i) => ({
      ...chave,
      isPrincipal: i === index,
    }));
    setChaves(novasChaves);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const chavesValidas = chaves
      .filter((chave, index) => index === 0 || segundoPix)
      .filter((chave) => chave.tipo.trim() && chave.chave.trim());

    if (chavesValidas.length === 0) {
      toast.warning("Você deve preencher pelo menos uma chave Pix.");
      return;
    }

    const algumaPrincipal = chavesValidas.some((c) => c.isPrincipal);
    if (!algumaPrincipal) {
      toast.warning("Você deve marcar uma das chaves como principal.");
      return;
    }

    try {
      const payload = {
        chavesPix: chavesValidas,
      };

      await api.put(`/auth/user/update/${userData.uid}`, payload);
      toast.success("Dados de pagamento atualizados com sucesso!");
      await fetchLoggedUser();

      if (cadastroObrigatorio) {
        window.location.reload();
      }

      onClose();
    } catch (error) {
      exibirLogs &&
        console.error("Erro ao atualizar dados de pagamento:", error);
      toast.error("Erro ao atualizar os dados de pagamento. Tente novamente.");
    }
  };

  const handleChange = (index, field, value) => {
    const novasChaves = [...chaves];

    if (field === "chave") {
      const tipo = novasChaves[index].tipo;

      if (tipo === "cpf" || tipo === "cnpj") value = formatCpfCnpj(value);
      else if (tipo === "telefone") value = formatPhone(value);
    }

    novasChaves[index][field] = value;
    setChaves(novasChaves);
  };

  const handleAttemptClose = () => {
    if (cadastroObrigatorio) {
      toast.info("É necessário cadastrar uma chave Pix para continuar.");
    } else {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      centered
      backdrop={cadastroObrigatorio ? "static" : true}
      keyboard={!cadastroObrigatorio}
    >
      <ModalHeader >
        Cadastro de Chaves Pix
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 8 }}>
            Dados para recebimento sobre receita
          </div>

          {chaves.map((chave, index) => {
            if (index === 0 || (index === 1 && segundoPix)) {
              return (
                <div key={index} className="mb-4 border p-3 rounded">
                  <p>
                    <b>Chave pix {index + 1}</b>
                  </p>
                  <FormGroup>
                    <Label for={`tipo-${index}`}>Tipo</Label>
                    <Input
                      disabled={!userData?.chavesPix ? false : true}
                      type="select"
                      id={`tipo-${index}`}
                      value={chave.tipo}
                      onChange={(e) =>
                        handleChange(index, "tipo", e.target.value)
                      }
                    >
                      <option value="">Selecione</option>
                      <option value="email">Email</option>
                      <option value="cpf">CPF</option>
                      <option value="cnpj">CNPJ</option>
                      <option value="telefone">Telefone</option>
                      <option value="aleatoria">Chave Aleatória</option>
                      <option value="copiaCola">Copia e Cola</option>
                    </Input>
                  </FormGroup>

                  <FormGroup>
                    <Label for={`chave-${index}`}>Chave</Label>
                    <Input
                      type="text"
                      id={`chave-${index}`}
                      value={chave.chave}
                      onChange={(e) =>
                        handleChange(index, "chave", e.target.value)
                      }
                      disabled={!userData?.chavesPix ? false : true}
                      placeholder="Digite a chave Pix"
                    />
                  </FormGroup>

                  <FormGroup check>
                    <Label check style={{display: 'flex', alignItems: 'center', gap: 5}}>
                      <Input
                        disabled={!userData?.chavesPix ? false : true}
                        type="radio"
                        name="principal"
                        checked={chave.isPrincipal}
                        onChange={() => handlePrincipalChange(index)}
                      />{" "}
                      Chave principal
                    </Label>
                  </FormGroup>
                </div>
              );
            }
            return null;
          })}

          <div className="d-flex justify-content-end mb-3">
            {!segundoPix ? (
              <Button
                color="primary"
                size="sm"
                outline
                block
                onClick={() => setSegundoPix(true)}
                disabled={
                  !userData?.chavesPix
                    ? false
                    : true ||
                      chaves[0]?.tipo.trim() === "" ||
                      chaves[0]?.chave.trim() === ""
                }
                style={{
                  opacity:
                    chaves[0]?.tipo.trim() === "" ||
                    (chaves[0]?.chave.trim() === "" && 0.3),
                }}
              >
                Cadastrar outra chave Pix
              </Button>
            ) : (
              <Button
                color="danger"
                outline
                block
                size="sm"
                onClick={() => {
                  setSegundoPix(false);
                  setChaves((prev) =>
                    prev.map((chave, i) =>
                      i === 1
                        ? { tipo: "", chave: "", isPrincipal: false }
                        : chave
                    )
                  );
                }}
              >
                Cancelar segunda chave
              </Button>
            )}
          </div>

          <div className="btnActions">
            <Button
              color="primary"
              disabled={!userData?.chavesPix ? false : true}
              onClick={handleSubmit}
              block
            >
              {!userData?.chavesPix ? "Salvar dados" : "Desativado no momento!"}
            </Button>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <small style={{ color: "#888" }}>
          O cadastro de pelo menos uma chave Pix é obrigatório. Marque uma como
          principal.
        </small>
      </ModalFooter>
    </Modal>
  );
}

export default ModalChavesPix;
